
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/tools-footer",
      function () {
        return require("private-next-pages/basic-elements/tools-footer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/tools-footer"])
      });
    }
  